/** Per-mode step colors (fast → balanced → deep), sampled by mode position. */
export const COMPOSER_MODE_GLOWS = ["#F9B45C", "#F56B10", "#E02615"];

/** Fixed gradient for the mode slider fill (fast → balanced → deep). */
export const COMPOSER_MODE_GRADIENT =
  "linear-gradient(90deg,#F9B45C 0%,#F56B10 50%,#D93A1E 100%)";

/** Accent dot / thumb color for the active mode. */
export const COMPOSER_MODE_ACCENT = "#F56B10";

/** Pick the color from a ramp at a fraction (0..1) of its length. */
export const sampleRamp = (ramp: string[], fraction: number): string =>
  ramp[Math.round(fraction * (ramp.length - 1))] ?? ramp[ramp.length - 1];
